import { render, staticRenderFns } from "./SalesPage.vue?vue&type=template&id=a8c0cce4"
import script from "./SalesPage.vue?vue&type=script&lang=js"
export * from "./SalesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports